import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { UsersResource } from '../resources/users.resource';
import { NotifyService } from '../../common/services/notify.service';
import { PASSWORD_PATTERN } from '../../config/password-policy';

@Component({
  selector: 'app-confirmation',
  template: `
    <div class="panel">
      <div class="panel-header">
        <div class="panel-logo">
          <img class="logo-img" width="80" height="80" src="assets/img/xplenty-logo.svg" alt="Prepforce" />
        </div>
        <h3 class="panel-title">{{ 'auth.confirmation.title' | translate }}</h3>
      </div>
      <div class="panel-body members-invitation">
        <xp-form-validation type="User">
          <form name="confirmationForm" novalidate autocomplete="off" #form="ngForm">
            <fieldset>
              <xp-form-group>
                <label>{{ 'auth.confirmation.form.labels.password' | translate }}</label>
                <input
                  class="form-control"
                  [(ngModel)]="password"
                  [placeholder]="'auth.confirmation.form.placeholders.password' | translate"
                  name="password"
                  type="password"
                  [pattern]="passwordPattern"
                  autocomplete="off"
                />
              </xp-form-group>
              <xp-password-strength [password]="password"></xp-password-strength>
              <small>{{ 'auth.confirmation.form.hints.password' | translate }}</small>
            </fieldset>
            <button
              type="button"
              class="btn btn-primary btn-lg btn-block"
              [ngClass]="{ disabled: !form.valid }"
              (click)="submit()"
            >
              {{ 'auth.confirmation.form.actions.create_user' | translate }}
            </button>
          </form>
        </xp-form-validation>
      </div>
    </div>
    <help-menu></help-menu>
  `,
})
export class ConfirmationComponent implements OnInit {
  @ViewChild('form') form: NgForm;
  password = '';
  passwordPattern = PASSWORD_PATTERN;

  constructor(
    private usersResource: UsersResource,
    private notify: NotifyService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    if (this.router.url.includes('/signup/confirmation')) {
      this.router.navigate(['/auth/confirmation'], { queryParams: { token: this.route.snapshot.params.token } });
    } else if (!this.route.snapshot.queryParams.token) {
      this.router.navigate(['/auth/login']);
    }
  }

  submit() {
    this.usersResource
      .confirm({
        password: this.password,
        confirmation_token: this.route.snapshot.queryParams.token,
      })
      .subscribe({
        next: () => {
          this.notify.success('User created successfully! Redirecting to log in');
          setTimeout(() => this.router.navigate(['/auth/login']), 3000);
        },
        error: ({ error }) => {
          const { errors } = error;
          if (errors && errors[0] && errors[0].field === 'confirmation_token') {
            this.notify.error(`Token ${errors[0].message}`);
          }
        },
      });
  }
}
